import { FetchState, UserInterestRate, InterestRateTableItem } from "@/shared/types";
import { InterestRateState } from "@/employer/types";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";
import { getUserInterestRates } from "@/shared/api/userService";
import { formatCurrency } from "@/shared/currency";

export const initialState: InterestRateState = {
  fetchState: FetchState.Uninitialized,
  username: "",
  interestRates: []
};

export const useInterestRateStore = defineStore("interestRate", {
  state: (): InterestRateState => (_.cloneDeep(initialState)),
  getters: {
      isUninitialized: state => state.fetchState === FetchState.Uninitialized,
      isLoaded: state => state.fetchState === FetchState.Loaded,
      isLoading: state => state.fetchState === FetchState.Loading,
      isFailed: state => state.fetchState === FetchState.Failed,
      getInterestRatesAsTableData: state => state.interestRates.map(x => mapInterestRateTableItem(x)),
  },
  actions: {
      loadInterestRates (args?: { username: string, partnerId: number }) {
          if (args !== undefined && this.username === args.username) {
              return;
          } else if (args === undefined && this.fetchState === FetchState.Loaded) {
              return;
          }

          this.interestRates = [];
          this.fetchState = FetchState.Loading;

          getUserInterestRates(args)
              .then(response => {
                  this.username = args !== undefined ? args.username : "";
                  this.fetchState = FetchState.Loaded;
                  this.interestRates = response.data.interestRates;
              })
              .catch(error => {
                  this.interestRates = [];
                  this.fetchState = FetchState.Failed;
                  return storeHelper.handleError({ error, rethrow: false });
              });
      }
  }
});

const mapInterestRateTableItem = (tier: UserInterestRate): InterestRateTableItem =>  {
    return {
        balance: getInterestRateBalanceDisplay(tier),
        interestRate: getInterestRateDisplay(tier)
    };
};

const getInterestRateBalanceDisplay = (tier: UserInterestRate) => {
    const balanceMin = formatCurrency(tier.balanceMin);

    if (tier.balanceMax > 0) {
        const balanceMax = formatCurrency(tier.balanceMax);
        return `${balanceMin} - ${balanceMax}`;
    }

    return `${balanceMin} and up`;
};

const getInterestRateDisplay = (tier: UserInterestRate) => {
    const percent = tier.interestRate * 100;
    return `${percent.toFixed(2)}%`;
};
